import React from "react";
import styles from "./LoanTextTeaser.scss";
import cx from "../../utils/cx";
import ButtonRound from "../ButtonRound";

export interface ILoanTextTeaserProps {
  className?: string;
}

const LoanTextTeaser: React.FC<React.PropsWithChildren<ILoanTextTeaserProps>> = ({ className = '' }) => {
  return <div className={cx(styles.loanTextTeaser, className)}>
    <div className="wgl-loan-calculator snipcss-q6Xza">
      <h3>
        Wohnglück Baufinanzierung: Verwirkliche deine Wohnträume!
      </h3>
      <div>
        <p>
          Noch nie war die Finanzierung einer Immobilie so einfach: Wir vermitteln dir einen günstigen Kredit – schnell und unkompliziert..
        </p>

        <ButtonRound variant="outlinedRound" data-da-einstiegsverkettung="Baufinanzierung" title="Günstigen Hauskredit sichern" href="https://pia.wohnglueck.de/frontend/template/wohnglueck-produkt.html?produkt=baufinanzierung-wohnglueck">
          Günstigen Hauskredit sichern »
        </ButtonRound>

      </div>
    </div>
  </div>
};

export default LoanTextTeaser;
